import type {
	PortalStatementDetailResponseDto,
	PortalStatementListResponseDto,
	PortalStatementQueryDto,
} from '@supply-mover-2-0/shared';
import {
	buildQueryString,
	portalFetch,
	portalFetchBlob,
} from '../lib/apiClient';

/**
 * Fetch the paginated statement list across the user's assigned clients.
 */
export async function getStatements(
	token: string,
	params: PortalStatementQueryDto,
): Promise<PortalStatementListResponseDto> {
	const qs = buildQueryString({
		page: params.page,
		limit: params.limit,
		clientId: params.clientId,
		dateFrom: params.dateFrom,
		dateTo: params.dateTo,
	});
	return portalFetch<PortalStatementListResponseDto>(`/statements${qs}`, token);
}

/**
 * Fetch a single statement with its rendered snapshot.
 */
export async function getStatementDetail(
	token: string,
	statementId: number,
): Promise<PortalStatementDetailResponseDto> {
	return portalFetch<PortalStatementDetailResponseDto>(
		`/statements/${statementId}`,
		token,
	);
}

/**
 * Download a statement PDF — rendered on the fly from the stored snapshot.
 */
export async function downloadStatementPdf(
	token: string,
	statementId: number,
): Promise<Blob> {
	return portalFetchBlob(`/statements/${statementId}/pdf`, token);
}
